// extracted by mini-css-extract-plugin
export default {"card":"H4-z"};